import {takeLatest} from 'redux-saga/effects';

import {createPostSaga} from './createPost/saga';
import {createPostACS} from './requestAC';

export function* postSaga() {
  yield takeLatest(createPostACS.type, createPostSaga);
}
